interface SeoMetaInput {
  title?: string;
  description?: string;
  canonical?: string;
  robots?: string;
  ogType?: 'website' | 'article';
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
}

export const SEO_SITE_ORIGIN = 'https://www.walletgate.app';

function ensureMeta(selector: string, attrs: Record<string, string>): HTMLMetaElement {
  const existing = document.head.querySelector<HTMLMetaElement>(selector);
  if (existing) return existing;
  const meta = document.createElement('meta');
  Object.entries(attrs).forEach(([k, v]) => meta.setAttribute(k, v));
  document.head.appendChild(meta);
  return meta;
}

function setMetaByName(name: string, content: string): void {
  const tag = ensureMeta(`meta[name="${name}"]`, { name });
  tag.setAttribute('content', content);
}

function setMetaByProperty(property: string, content: string): void {
  const tag = ensureMeta(`meta[property="${property}"]`, { property });
  tag.setAttribute('content', content);
}

function setCanonical(url: string): void {
  const existing = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (existing) {
    existing.setAttribute('href', url);
    return;
  }
  const link = document.createElement('link');
  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', url);
  document.head.appendChild(link);
}

export function applySeoMeta(input: SeoMetaInput): void {
  if (typeof document === 'undefined') return;

  if (input.title) document.title = input.title;
  if (input.description) setMetaByName('description', input.description);
  if (input.robots) setMetaByName('robots', input.robots);
  if (input.canonical) setCanonical(input.canonical);

  if (input.ogType) setMetaByProperty('og:type', input.ogType);
  if (input.ogTitle) setMetaByProperty('og:title', input.ogTitle);
  if (input.ogDescription) setMetaByProperty('og:description', input.ogDescription);
  if (input.ogUrl) setMetaByProperty('og:url', input.ogUrl);
  if (input.ogImage) setMetaByProperty('og:image', input.ogImage);

  if (input.twitterTitle) setMetaByName('twitter:title', input.twitterTitle);
  if (input.twitterDescription) setMetaByName('twitter:description', input.twitterDescription);
  if (input.twitterImage) setMetaByName('twitter:image', input.twitterImage);
}
